module.exports = __webpack_public_path__ + "static/media/host.9fa0e771.png";